import React from 'react'
import { Link} from 'react-router-dom'
import { useState } from 'react'
import Loadersspinners from './Loaders/LoadersSpinners';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Baseurl } from '../constants/env';
import Button from 'react-bootstrap/esm/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';


const Register = () => {
  
  const navigate = useNavigate();
  const [Loading,setLoading]=useState(false);
  const [firstname,setFirstname] = useState();
  const [lastname,setLastname] = useState(); 
  const [email,setEmail] = useState();
  const [mobile,setMobile] = useState();


  const [isChecked, setIsChecked] = useState(false);
    const handleYes = () => {
      setIsChecked(true);
    };
  
    const handleNo = () => {
      setIsChecked(false);
    };



  const [Password,setPassword] = useState();
  const{enqueueSnackbar} = useSnackbar();

  const Data = async (e) => {
    e.preventDefault();
    setLoading(true);
    // console.log(Username , Password);
    // JSON.stringify(Username , Password);
    let data = {
      firstname,
      lastname,
      email,
      mobile,
      termsandcondition:isChecked,
      password:Password
    }
   //JSON.stringify(data);
  await axios.post(`${Baseurl}/register`,data).then((resp)=>{
    setFirstname('');
    setPassword('');
    setLoading(false);
  if(resp.status === 201){
    enqueueSnackbar('Registration Success Please Log IN',{variant:'success'})
    navigate('/login',{replace:true});
  }else{
    enqueueSnackbar('Something Went Wrong Please Register After Some Time',{variant:'error'})
    navigate('/register');
  }
  //console.log(resp);
}).catch((err)=>{
  //setFirstname('');
  //setPassword('');
  console.log(err);
  
  enqueueSnackbar('This username is already exist ' + err.message,{variant:'error'})
  setLoading(false)
});
   }

   const handleNameChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
  };

  return (
 <>
<main className='main'>
 <section class="section-contact-us" style={{marginTop:'25px'}}>
       <div class="container">
         <div class="row">
           <div class="col-md-12">
             <nav aria-label="breadcrumb">
               <ol class="breadcrumb">
                 <li class="breadcrumb-item"><Link to="/">Home</Link></li>
                 <li class="breadcrumb-item active" aria-current="page">
                   Register
                 </li>
               </ol>
             </nav>
           </div>
         </div>
         <div class="row">
           <div class="col-md-12">
             <div class="contact-form register-form text-center">
               <h3 class="mb-0">Register!</h3>
               <p>Enter your details below.</p>
 
               <form method='post' className='Register__form' onSubmit={Data} >
                 <div class="mb-3 mt-5">
                   <input value={firstname} onChange={(e)=>{setFirstname(e.target.value)}} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Firstname" />
                 </div>
                 <div class="mb-3">
                   <input value={lastname} onChange={(e)=>{setLastname(e.target.value)}} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Lastname" />
                 </div>
                 <div class="mb-3">
                   <input  value={email} onChange={(e)=>{setEmail(e.target.value)}} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Email" />
                 </div>
                 <div class="mb-3">
                   <input value={mobile} onChange={(e)=>{setMobile(e.target.value)}} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Mobile" />
                 </div>
                 <div className='d-flex mb-3 '>
        
          </div> 
                 <div class="mb-2">
                   <input  value={Password} onChange={(e)=>{setPassword(e.target.value)}} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Password" />
                 </div>
                 <label className='d-flex text-dark align-items-center'> <span className='mb-4'>
           <input
            className='form-check-input mt-4'
              type="checkbox"
              onChange={(event) => {handleNameChange(event)}}
              style={{ marginRight: '8px' }}
            />
         </span> Are you Agreeing our terms and conditions
          
           </label>
 
                 <button type="submit" onClick={Data} class="btn btn-primary-theme d-block w-100 mb-4">
                   Submit
                 </button>
 
               </form>
             </div>
           </div>
         </div>
       </div>
     </section>

     </main>
    

         {/* <div className='mt-5' style={{backgroundColor:'violet',width:'100%',height:'100vh',display:'flex',justifyContent:'center',alignItems:'center',flexWrap:'wrap'}}>
      <form name='registerform' method='post' className='Register__form' onSubmit={Data} style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}} >
      <h1 className='Register__h1 text-white text-center' style={{marginBottom:'20px'}}>Register</h1>
     
      <input type='text' className='Register__input text-center' style={{marginBottom:'5px',border:'1px solid white',borderRadius:'12px'}} placeholder='Firstname'
      value={firstname} onChange={(e)=>{setFirstname(e.target.value)}}></input>

     <input type='text' className='Register__input text-center' style={{marginBottom:'5px',border:'1px solid white',borderRadius:'12px'}} placeholder='Lastname'
      value={lastname} onChange={(e)=>{setLastname(e.target.value)}}></input>

     <input type='text' className='Register__input text-center' style={{marginBottom:'5px',border:'1px solid white',borderRadius:'12px'}} placeholder='Email'
      value={email} onChange={(e)=>{setEmail(e.target.value)}}></input>

     <input type='number' className='Register__input text-center' style={{marginBottom:'5px',border:'1px solid white',borderRadius:'12px'}} placeholder='Mobile Number'
      value={mobile} onChange={(e)=>{setMobile(e.target.value)}}></input>

<div className='d-flex '>
           <label className='d-flex text-white align-items-center justify-content-center'>Are you Agreeing our terms and conditions
           <span className='ms-5'>
           <ButtonGroup>
      <Button
        variant={isChecked ? 'primary' : 'outline-primary'}
        onClick={handleYes}
      >
        Yes
      </Button>
      <Button
        variant={!isChecked ? 'primary' : 'outline-primary'}
        onClick={handleNo}
      >
        No
      </Button>
    </ButtonGroup> </span>
           </label>
          </div> 
      
      <input type='Password' className='Register__password text-center mt-2' style={{marginBottom:'15px',border:'1px solid white',borderRadius:'12px'}} placeholder='Password'
      value={Password} onChange={(e)=>{setPassword(e.target.value)}}></input>

      <Button type='submit'  disabled={Loading} style={{border:'1px solid white',borderRadius:'12px'}} className='Register__btn'>Register</Button>
     </form>
           
            <div><Button className='login__Home__Btn' style={{border:'1px solid white',borderRadius:'12px'}}><Link className='text-white' style={{textDecoration:'none'}} to='/'>Back Home</Link></Button></div>
         </div> */}
  </>  
  )
}

export default Register